








































































import {
    Component,
    Prop,
    Vue,
    ComponentStyle,
    ComponentStyleDefinition,
    VueComponent,
    QuestionType,
    InjectComponent,
    Question,
    Watch,
    FilterPanelSettings,
    FilterQuestionSettings,
    ChoiceQuestion
} from "@zoovu/runner-browser-api";
import { FiltersSettings } from './types';

@Component({})
export default class FilterQuestionView extends Vue {

    @Prop()
    question: Question;

    @Prop()
    readonly panelSettings: FilterPanelSettings;

    @Prop()
    initiallyExpanded: boolean;

    @ComponentStyle()
    componentStyle: ComponentStyleDefinition;

    @InjectComponent("FilterCheckboxAnswerView")
    filterCheckboxAnswer: VueComponent;

    @InjectComponent("FilterRadioButtonAnswerView")
    filterRadioButtonAnswer: VueComponent;

    @InjectComponent("SliderQuestionView")
    sliderQuestion: VueComponent;

    @InjectComponent("RangeQuestionView")
    rangeQuestion: VueComponent;

    @InjectComponent("FilterDropDownQuestionView")
    filterDropDownQuestion: VueComponent;

    @InjectComponent("InfoText")
    infoText: VueComponent;

    isExpanded: boolean = Boolean(this.initiallyExpanded);

    infoTextShown: boolean = false;

    showAllAnswers: boolean = false;

    showInfoText() {
        this.infoTextShown = true;
    }

    hideInfoText() {
        this.infoTextShown = false;
    }

    get questionSettings(): FilterQuestionSettings {
        return this.question.parameters ? this.question.parameters : {};
    }

    get answersLimitingEnabled(): boolean {
        return typeof this.questionSettings[FiltersSettings.LIMIT_SHOWN_ANSWERS] === 'number';
    }

    get shouldShowMoreButton(): boolean {
       if (this.question.questionType === QuestionType.CHECKBOX || this.question.questionType === QuestionType.RADIO) {

            const choiceQuestion = this.question as ChoiceQuestion;
            if (
                this.answersLimitingEnabled &&
                this.questionSettings[FiltersSettings.LIMIT_SHOWN_ANSWERS] < choiceQuestion.answers.length
            ) {
                return true;
            }
            return false;
        }
    }

    get QuestionType(): typeof QuestionType {
        return QuestionType;
    }

    get toggleShowAllAnswersText(): string {
        return this.showAllAnswers ? "message-filter-less" : "message-filter-more";
    }

    toggleShowAllAnswers(): void {
        this.showAllAnswers = !this.showAllAnswers;
    }

    toggleExpanded(): void {
        this.isExpanded = !this.isExpanded;
    }

    @Watch("initiallyExpanded")
    updateExpanded(): void {
        this.isExpanded = this.initiallyExpanded;
    }

    get choiceAnswersToDisplay() {
        if (this.question.questionType === QuestionType.CHECKBOX || this.question.questionType === QuestionType.RADIO) {

            const choiceQuestion = this.question as ChoiceQuestion;
            if (this.answersLimitingEnabled && !this.showAllAnswers) {
                return choiceQuestion.answers.slice(0, this.questionSettings[FiltersSettings.LIMIT_SHOWN_ANSWERS])
            }
            return choiceQuestion.answers;
        }
    }

    get showDisabledAnswers(): boolean {
        if (typeof this.questionSettings[FiltersSettings.SHOW_DISABLED_AS_GREYED_OUT] === 'boolean') {
            return this.questionSettings[FiltersSettings.SHOW_DISABLED_AS_GREYED_OUT];
        }

        return this.panelSettings ? !!this.panelSettings[FiltersSettings.SHOW_DISABLED_AS_GREYED_OUT] : false;
    }

    get hideOptionLabels(): boolean {
        if (typeof this.questionSettings[FiltersSettings.HIDE_OPTION_LABELS] === 'boolean') {
            return this.questionSettings[FiltersSettings.HIDE_OPTION_LABELS];
        }

        return this.panelSettings ? !!this.panelSettings[FiltersSettings.HIDE_OPTION_LABELS] : false;
    }
}
